import request from '@/utils/request'

// 企业资料
export function agentInformation(params) {
  return request({ url: '/taxapi/tax/getCompanyInfo', method: 'get', params })
}

// 修改个人/企业资料
export function modifyInfo(data) {
  return request.post('/taxapi/tax/updateCompanyInfo', data)
}

// 管理员列表
export function operatorList(params) {
  return request.get('/taxapi/tax/operatorList', { params })
}

// 编辑管理员
export function editOperator(data) {
  return request.post('/taxapi/tax/editOperator', data)
}

// 添加管理员
export function addOperator(data) {
  return request.post('/taxapi/tax/addOperator', data)
}

// 启/禁用管理员状态
export function operatorStatus(data) {
  return request.post('/taxapi/tax/operatorStatus', data)
}

